module.exports = __webpack_public_path__ + "static/media/3.05d6a549.jpg";